import React from 'react';
import { templateLibrary } from '../data/resources';
import { templateSamples } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
import { BonusOfferTag } from './BonusOfferTag';
export function TemplateLibrary() {
  return <section aria-labelledby="library-title" className="on-dark bg-teal text-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-191" data-mp="1cgsvm2rjxwfp">
      <div className="max-w-6xl mx-auto" data-id="element-192" data-mp="1hfm9hwar3pge">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-193" data-mp="jv9gha3twcvg">
          <div className="lg:col-span-6" data-id="element-194" data-mp="ot1gysijh7b9">
            <div className="rounded-[2rem] overflow-hidden aspect-square ring-1 ring-gold/40" data-id="element-195" data-mp="ott2tbmc3qoc">
              <img src={templateLibrary.image} alt={templateLibrary.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-196" data-mp="tqtafqyu11hk" />
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-197" data-mp="12nqv7jilijb">
            <p className="font-serif text-lg font-semibold text-coral-light" data-id="element-198" data-mp="11macnjqc3u7">Bonus 5</p>
            <div className="mt-3" data-id="element-199" data-mp="60yvn3uyd2uo">
              <BonusOfferTag referencePrice={templateLibrary.referencePrice} onDark data-id="element-200" data-mp="2q670ewdoq6wr" />
            </div>
            <h2 id="library-title" className="mt-5 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-201" data-mp="2l7nakkvz0az4">
              Plus de 100 modèles pour continuer à créer
            </h2>
            <div className="mt-5 h-px w-16 bg-gold" aria-hidden="true" data-id="element-202" data-mp="2bhu23sr4kbz3" />
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-ivory/85 max-w-lg" data-id="element-203" data-mp="2bfhmvncr4fpq">
              Après vos premiers exercices, explorez une bibliothèque de motifs
              variés et choisissez votre prochaine création.
            </p>

            <dl className="mt-9 grid sm:grid-cols-2 gap-px rounded-2xl overflow-hidden bg-ivory/15" data-id="element-204" data-mp="1xgzuvdftch20">
              <div className="bg-teal p-5" data-id="element-205" data-mp="1sjrkhz0wphbb">
                <dt className="font-serif text-lg font-semibold" data-id="element-206" data-mp="1sksyocd7yjx9">Mes modèles à tracer</dt>
                <dd className="mt-1 text-sm leading-relaxed text-ivory/80" data-id="element-207" data-mp="3rv0yscq7zu8y">
                  Des formes simples pour vous entraîner au tracé.
                </dd>
              </div>
              <div className="bg-teal p-5" data-id="element-208" data-mp="1l5z2buqhdewu">
                <dt className="font-serif text-lg font-semibold" data-id="element-209" data-mp="1pya4734s7as1">100+ modèles</dt>
                <dd className="mt-1 text-sm leading-relaxed text-ivory/80" data-id="element-210" data-mp="1q03a2g7klqyz">
                  Des motifs plus élaborés pour vos prochaines créations.
                </dd>
              </div>
            </dl>

            <p className="mt-6 text-sm text-ivory/80" data-id="element-211" data-mp="1g64e5yy3b3fh">
              Des modèles à tracer, en complément des 6 projets guidés.
            </p>

            <a href="#offre" className="mt-9 inline-flex w-full sm:w-auto justify-center whitespace-nowrap rounded-full bg-ivory px-8 py-4 text-base font-semibold text-teal hover:bg-sand transition-colors duration-200" data-id="element-212" data-mp="28w36c37kzgod">
              Je découvre le pack — {siteConfig.price}
            </a>
          </div>
        </div>

        {templateSamples.length > 0 && <ul className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-213" data-mp="jkkhvdvvuukh">
            {templateSamples.map(t => <li key={t.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-ivory" data-id="element-214" data-mp="g00ir4d4bxau">
                <img src={t.src} alt={t.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-215" data-mp="b17em2jq1inc" />
              </li>)}
          </ul>}
      </div>
    </section>;
}